import { watch } from 'vue'
import { FREE_PLAN_LIMITS } from '@/config/plan'
import { useDatabaseStore } from '@/stores/database'
import { useFoldersStore } from '@/stores/folders'
import { usePlanStore } from '@/stores/plan'
import { logger } from '@/utils/logger'

/**
 * Keeps the local folders in line with the current plan: the Free plan only keeps
 * `FREE_PLAN_LIMITS.maxFolders` folders active, other plans re-activate all of them.
 */
export function usePlanEnforcement () {
    const planStore = usePlanStore()
    const foldersStore = useFoldersStore()
    const databaseStore = useDatabaseStore()

    watch(() => planStore.plan, async plan => {
        if (!plan) {
            return
        }

        try {
            await databaseStore.whenReady()
            await foldersStore.loadFolders()
            await foldersStore.applyActiveFolderLimit(plan === 'free' ? FREE_PLAN_LIMITS.maxFolders : null)
        } catch (error) {
            logger.error('Failed to apply plan folder limit:', error)
        }
    }, { immediate: true })
}
